import React from 'react';
import styled from 'styled-components';

const DetailBox = (props) => {
    return (
        <>
            <Box sty={props.sty}>
                <div className="contents">
                    {
                        props.result.map((data, index) => {
                            return (
                                <p key={index} className="text" dangerouslySetInnerHTML={ {__html: data.html} }></p>
                            )
                        })
                    }
                </div>
            </Box>
        </>
    );
};

const Box = styled.div`
    margin-top: ${props => props.sty};
    .contents {
        p {
            font-size: 14.5px;
            font-weight: 500;
            line-height: 2.1;
            & + p {
                margin-top: 45px;
            }

            span {
                &.first {
                    font-size:49px;
                    font-weight: 400;
                    line-height: 1.2;
                    float:left;
                }
                &.left {
                    margin-left: 10px;
                }
                &.emphasis {
                    background-color:#dde9ed;
                }
            }
        }
    }
`;

export default DetailBox;
